"use strict"
// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyC0yHuDKy6sznIQmrecwm_ypA1_uJZh7IM",
    authDomain: "beatrice-gold.firebaseapp.com",
    projectId: "beatrice-gold",
    storageBucket: "beatrice-gold.appspot.com",
    messagingSenderId: "627143034268",
    appId: "1:627143034268:web:8658cab897021b5fd47459"
};
// Initialize Firebase
var firebaseApp = firebase.initializeApp(firebaseConfig);


// function createUser(user) {
//   fetch(newUser_url, {
//     method: "POST",
//     headers: {
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({ data: user }),
//   })
//     .then(function (responseOne) {
//       return responseOne.json();
//     })
//     .then(function (serverResponse) {
//       if (serverResponse.success) {
//         let serverCredentials = {
//           email: credentials.email,
//           id_token: "",
//         };
//         firebaseSignIn(serverCredentials, credentials.password);
//         // const dispatch = useDispatch();
//       } else {
//       }
//     })
//     .catch(function (error) {
//       console.error(error);
//     });
// }

// function _checkAuth() {
//   auth.onAuthStateChanged(function (user) {
//     if (user) {
//       user.getIdToken().then(function (auth) {
//         let idToken = auth;
//         console.log("Token! ", auth);
//         let serverCredentials = {
//           email: user.email,
//           id_token: idToken,
//         };
//         _loginServer(serverCredentials, null);
//         hideSplash();
//         hideLogin();
//       });
//     } else {
//       console.log("User not signed in ", user);
//       let token = appStorage.getItem(REALITY_MGMT_JWT_TOKEN);
//       console.log("token", token);
//       hideSplash();
//       showLogin();
//       // getUsers();
//     }
//   });
// }

// /************************************************************
//       Firebase Sign In
//   /*************************************************************/

// function firebaseSignIn(serverCredentials, password) {
//   auth
//     .signInWithEmailAndPassword(serverCredentials.email, password)
//     .then(function (response) {
//       let user = response.user;
//       console.log("Signed In User! ", user.refreshToken, user.uid);
//       user.getIdToken().then(function (auth) {
//         let idToken = auth;
//         console.log("Token! ", idToken);
//         let serverCredentials = {
//           email: user.email,
//           id_token: idToken,
//         };
//         _loginServer(serverCredentials, password);
//       });
//     })
//     .catch(function (error) {
//       console.log("emailSignIn ", error);
//       // Handle Errors here.
//       let errorCode = error.code;
//       let errorMessage = error.message;
//       ALERT_TITLE = "Login Error";
//       switch (errorCode) {
//         case "auth/user-not-found":
//           window.alert("User Account Not Found!", "Login Error");
//           break;
//         case "auth/invalid-email":
//           window.alert("Invalid Email!", "Login Error");
//           break;
//         case "auth/user-disabled":
//           window.alert("User is disabled!", "Login Error");
//           break;
//         case "auth/wrong-password":
//           window.alert("Wrong Password!", "Login Error");
//           break;
//         default:
//           window.alert(error.message, "Login Error");
//           break;
//       }
//     });
// }

// /************************************************************
//       Login to the server
//   /*************************************************************/

// function _loginServer(serverCredentials, password) {
//   console.log("Server", serverCredentials);

//   fetch(login_url, {
//     method: "POST",
//     headers: {
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(serverCredentials),
//   })
//     .then(function (responseOne) {
//       return responseOne.json();
//     })
//     .then(function (serverResponse) {
//       if (serverResponse.success) {
//         // console.log("Innersense User! ", serverResponse);
//         let innersenseUser = serverResponse.data;
//         let serverUser = new RealityMgmtUser(
//           innersenseUser.firstName,
//           innersenseUser.lastName,
//           innersenseUser.orgs,
//           innersenseUser.role,
//           innersenseUser.address,
//           innersenseUser.email,
//           innersenseUser.isFirstTime,
//           innersenseUser.isAdmin,
//           innersenseUser.uid,
//           innersenseUser.photoURL,
//           innersenseUser.stripeID,
//           innersenseUser.subscriptionLevel
//         );
//         user = serverUser;
//         dispatch(sessionStateInit(user));
//         // getUsers();
//         appStorage.setItem(REALITY_MGMT_JWT_TOKEN, serverResponse.accessToken);
//         appStorage.setItem(REALITY_MGMT_UID, serverResponse.data.uid + "___" + serverResponse.data.email);
//       } else {
//         if (null != password) {
//           firebaseSignIn(serverCredentials, password);
//         }
//       }
//     })
//     .catch(function (error) {
//       console.error(error);
//     });
// }